module.exports = __webpack_public_path__ + "media/images/weather/401_night-430e95cdb76d3ddbeb94f1dd22872493.png";